
<template>
  <div>
    <form v-on:submit.prevent="submitSearch">
      <div class="input-group input-group--search">
        <label for="input-search" class="input-group">
          <input
            type="text"
            class="input"
            id="input-search"
            :placeholder="$t('searchPlaceholderText')"
            v-model="query"
            v-on:blur="inputBlur"
            v-on:input="queryChange"
            autocomplete="off"
          >
          <div class="icon">
            <svg
              width="22px"
              height="22px"
              viewBox="0 0 40 40"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <title>Search Icon</title>
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <circle
                  class="icon__circle"
                  stroke="#000000"
                  stroke-width="2"
                  fill-rule="nonzero"
                  cx="16.5"
                  cy="16.5"
                  r="12.5"
                ></circle>
                <path
                  class="icon__line"
                  d="M24.5,26.5 L34.0480957,36.0480957"
                  stroke="#000000"
                  stroke-width="2"
                  stroke-linecap="square"
                  fill-rule="nonzero"
                ></path>
              </g>
            </svg>
          </div>
        </label>
        <div
          class="autocomplete-results"
          @mouseover="isHovering"
          @mouseleave="notHovering"
          v-show="isOpen"
        >
          <p class="suggestion-title">{{$t('topArticlesTextZen')}}</p>
          <ul>
            <router-link
              v-for="(result, i) in results"
              :key="i"
              class="no-underline"
              :to="{name: 'article', hash: getHash(result)}"
              v-on:click.native="closeSuggestions"
            >
              <li class="autocomplete-result">
                <p class="autocomplete-result-title">
                  <span v-html="result.htmlTitle"></span>
                  <span class="autocomplete-result-category">-</span>
                  <span class="autocomplete-result-category">{{result.category}}</span>
                </p>
              </li>
            </router-link>
          </ul>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {
  getLanguage,
  getPageHash,
  searchLocalArticles,
  formatArticleTitles,
  getCategoryIdByArticleId,
  getCategoryById
} from '@/utils/common';

export default {
  data: () => {
    return {
      query: '',
      articles: [],
      results: [],
      isOpen: false,
      hovering: false
    };
  },
  created: function() {
    const matches = this.$route.hash.match(new RegExp('query' + '=([^&]*)'));
    this.query = matches ? decodeURIComponent(matches[1]).replace(/\+/g, ' ') : null;
  },
  methods: {
    getHash(article) {
      return getPageHash(article);
    },
    submitSearch() {
      const lng = getLanguage();
      const urlQuery = this.query ? this.query.replace(/ /g, '+') : '';
      this.closeSuggestions();
      const newUrl = `/${lng}/search#query=${urlQuery}`;
      this.$router.push(newUrl);
      if (window.location.href.includes('search')) {
        this.$router.go(0);
      }
    },
    queryChange() {
      if (this.query === '') {
        this.isOpen = false;
        return;
      }
      this.filterResults();
    },
    filterResults() {
      const queries = this.query.split(' ').map(query => new RegExp(`(${query})`, 'i'));

      this.articles = searchLocalArticles(queries);
      const articles = formatArticleTitles(this.articles, this.query);

      const suggestions = articles.map(article => {
        const catId = getCategoryIdByArticleId(article.id);
        const { title } = getCategoryById(catId);
        return { ...article, category: title };
      });

      if (suggestions.length === 0) {
        this.results = [];
        this.isOpen = false;
        return;
      }
      this.isOpen = true;
      this.results = suggestions.slice(0, 6);
    },
    inputBlur() {
      if (!this.hovering) {
        this.isOpen = false;
      }
    },
    closeSuggestions() {
      this.isOpen = false;
    },
    isHovering() {
      this.hovering = true;
    },
    notHovering() {
      this.hovering = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.input-group--search {
  margin: 0 auto;
  max-width: 60%;
  position: relative;
  text-align: left;

  .input {
    border: 0;
    font-size: 18px;
    height: 60px;
    width: 100%;
    padding: 16px 80px 16px 30px;
    font-weight: 300;
    color: #333;
    outline: none;
    border-radius: 30px;
    background: #fff;

    &::placeholder {
      color: #333;
      opacity: 1;
    }
  }
  .icon {
    position: absolute;
    right: 0;
    top: 0;
    width: 72px;
    height: 60px;
    background: #EAF2FF;
    border-radius: 0 30px 30px 0;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      .icon__circle,
      .icon__line {
        stroke: #287EFF;
      }
    }
  }
  &:focus {
    outline: none;
    border: none;
  }
}
.suggestion-title {
  border-bottom: 1px solid #f3f3f3;
  color: #333;
  font-size: 16px;
  margin: 0;
  padding: 15px;
}
.autocomplete-results {
  margin: 0;
  border: 1px solid #eeeeee;
  border-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  overflow: auto;
  background-color: #fff;
}
.autocomplete-results ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  cursor: pointer;
  color: #555;
  padding: 8px 15px;
  p {
    margin: 0;
  }
}

.autocomplete-result-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.autocomplete-result:hover {
  background-color: #f4f4f4;
}

.autocomplete-result-category {
  color: #ccc;
  font-size: 80%;
  line-height: 19.6875px;
}
@media (max-width: 768px) {
  .input-group--search {
    max-width: 100%;
  }
  .input-group--search {
    .input {
      height: 50px;
      padding: 16px 60px 16px 30px;
      font-size: 16px;
    }
    .icon {
      width: 50px;
      height: 50px;
    }
  }
}

</style>
